import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export abstract class AbstractGuidedToursService {

  constructor() { }

  abstract trackUser(id: string, isTrial: boolean, gender: number): void;
}
